<template>
    <div class="achievement_container bg_white box_shadow bottom" v-if="consultancy.length > 0">
        <div class="achievement_content">
           <p v-html="consultancy.detail.achievements"></p>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    computed: {
        ...mapGetters(['consultancy'])
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ConsultancyProfile/_achievement.vue